import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import { FaChartArea } from "react-icons/fa";

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="sad-custom-tooltip">
        <p className="tooltip-title">{label}</p>
        {payload.map((item, index) => (
          <p key={index} style={{ color: item.color }}>
            {item.name}: <strong>{item.value}</strong>
          </p>
        ))}
      </div>
    );
  }
  return null;
};

export default function ActivityTimelineChart({ data = [] }) {
  const chartData = data.length > 0 ? data : [
    { name: "00:00", emisiones: 12, validaciones: 25 },
    { name: "04:00", emisiones: 5, validaciones: 10 },
    { name: "08:00", emisiones: 45, validaciones: 90 },
    { name: "12:00", emisiones: 78, validaciones: 140 },
    { name: "16:00", emisiones: 60, validaciones: 110 },
    { name: "20:00", emisiones: 30, validaciones: 55 },
  ];

  return (
    <div className="sad-card">
      <div className="sad-card-header">
        <span className="sad-card-title">
          <FaChartArea className="text-primary" /> Flujo Operativo: Emisiones vs Validaciones
        </span>
        <span className="sad-card-badge">Últimas 24 horas</span>
      </div>

      <div className="sad-chart-container">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={chartData} margin={{ top: 10, right: 20, left: -20, bottom: 0 }}>
            <defs>
              <linearGradient id="emisionesGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#1F2B68" stopOpacity={0.4} />
                <stop offset="95%" stopColor="#1F2B68" stopOpacity={0.0} />
              </linearGradient>
              <linearGradient id="validacionesGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#10B981" stopOpacity={0.4} />
                <stop offset="95%" stopColor="#10B981" stopOpacity={0.0} />
              </linearGradient>
            </defs>

            <CartesianGrid strokeDasharray="3 3" stroke="#F1F5F9" />
            <XAxis dataKey="name" stroke="#94A3B8" tick={{ fill: "#64748B", fontSize: 11 }} />
            <YAxis stroke="#94A3B8" tick={{ fill: "#64748B", fontSize: 11 }} />
            <Tooltip content={<CustomTooltip />} />
            <Legend wrapperStyle={{ paddingTop: "10px", fontSize: "12px", color: "#475569" }} />

            <Area
              type="monotone"
              dataKey="emisiones"
              name="Certificados Emitidos"
              stroke="#1F2B68"
              strokeWidth={2}
              fillOpacity={1}
              fill="url(#emisionesGradient)"
            />
            <Area
              type="monotone"
              dataKey="validaciones"
              name="Validaciones Consultadas"
              stroke="#10B981"
              strokeWidth={2}
              fillOpacity={1}
              fill="url(#validacionesGradient)"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
